module.exports = __webpack_public_path__ + "static/img/powered-by.3dd64ddb.svg";